export default __webpack_public_path__ + "static/sberdevices-23fefd4f63730f752be05cf4bfd813ef.svg";